import type { ListBuilderList } from '../../../types';
import {
	createAvgPerPurchaseColumn,
	createChartColumn,
	createItemColumnWithSuffix,
	createItemNumberColumn,
	createReorderInfoColumn,
	createReorderPurchaseInfoColumn,
	createReorderTotalsColumn,
} from '../columns';

/**
 * Due for Reorder list configuration
 * Shows items that are overdue for reorder based on purchase patterns
 */
export const dueForReorderList: ListBuilderList = {
	id: 'due-for-reorder',
	cacheTTL: 600000,
	name: 'Reorder',
	type: 'custom',
	active: true,
	filterRules: {
		viewType: { defaultValue: 'dueForReorder' },
	},
	columns: [
		createItemColumnWithSuffix('reorder'),
		createItemNumberColumn(),
		createReorderInfoColumn(),
		createReorderPurchaseInfoColumn(),
		createAvgPerPurchaseColumn(),
		createReorderTotalsColumn(),
		createChartColumn('Reorder'),
	],
	searchEnabled: true,
	searchPlaceholder: 'Search items...',
	sortOrder: 1,
};
